<script lang="ts">
  import Marquee from '$components/Marquee/index.svelte';
  export let isIndex = false;
</script>

<template lang="pug" src="./template.pug">
</template>
